var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 246.408,
    y2: 430.703
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb27e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.103,
    x2: 296.103,
    xlinkHref: "#lg2",
    y1: 246.408,
    y2: 430.703
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.095,
    x2: 236.332,
    xlinkHref: "#lg2",
    y1: 322.829,
    y2: 201.896
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 374.541,
    y2: 411.621
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 400.591,
    y2: 437.671
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 440.842,
    y2: 520.299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.727,
    x2: 246.825,
    y1: 553.709,
    y2: 444.548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    stopColor: "#674d66",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593b56"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 450.844,
    y2: 497.866
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 33.763,
    y2: 224.175
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.958,
    x2: 289.521,
    xlinkHref: "#lg2",
    y1: 150.798,
    y2: 30.81
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.177,
    x2: 175.061,
    xlinkHref: "#lg2",
    y1: 152.403,
    y2: 118.352
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.118,
    x2: 268.389,
    xlinkHref: "#lg2",
    y1: 225.875,
    y2: 54.812
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.302,
    x2: 299.321,
    xlinkHref: "#lg2",
    y1: 199.302,
    y2: 97.962
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.684,
    x2: 179.29,
    xlinkHref: "#lg2",
    y1: 183.435,
    y2: 135.602
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b62cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#985dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#8f4ec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833ac1"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(1 -.003 .003 1 -2.483 -.888)",
    gradientUnits: "userSpaceOnUse",
    x1: 394.43,
    x2: 484.751,
    xlinkHref: "#lg3",
    y1: 73.041,
    y2: 73.041
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(1 -.003 .003 1 -2.483 -.888)",
    gradientUnits: "userSpaceOnUse",
    x1: 28.753,
    x2: 119.074,
    xlinkHref: "#lg3",
    y1: 382.265,
    y2: 382.265
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(1 -.003 .003 1 -2.483 -.888)",
    gradientUnits: "userSpaceOnUse",
    x1: 386.073,
    x2: 449.944,
    xlinkHref: "#lg3",
    y1: 181.457,
    y2: 181.457
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(1 -.003 .003 1 -2.483 -.888)",
    gradientUnits: "userSpaceOnUse",
    x1: 81.759,
    x2: 145.63,
    xlinkHref: "#lg3",
    y1: 201.863,
    y2: 201.863
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(1 -.003 .003 1 -2.483 -.888)",
    gradientUnits: "userSpaceOnUse",
    x1: 375.465,
    x2: 439.336,
    xlinkHref: "#lg3",
    y1: 351.132,
    y2: 351.132
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(1 -.003 .003 1 -2.483 -.888)",
    gradientUnits: "userSpaceOnUse",
    x1: 43.508,
    x2: 107.38,
    xlinkHref: "#lg3",
    y1: 66.833,
    y2: 66.833
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m295.007 406.814h-80.014l-42.198-207.158h164.41z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 406.814h40.007l42.198-207.158h-82.205z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.412 390.097 38.793-190.441h-164.41l16.582 81.406z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m344.074 406.814h-178.148v-16.706c0-13.793 11.181-24.974 24.974-24.974h128.2c13.793 0 24.974 11.181 24.974 24.974z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.473 432.864h-218.946v-13.993c0-15.291 12.396-27.687 27.687-27.687h163.573c15.291 0 27.687 12.396 27.687 27.687v13.993z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.874 510h-225.748c-5.897 0-10.677-4.78-10.677-10.677v-67.96c0-5.897 4.78-10.677 10.677-10.677h225.748c5.897 0 10.677 4.78 10.677 10.677v67.96c0 5.897-4.78 10.677-10.677 10.677z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.955 441.896c-1.164-1.791-3.173-2.98-5.468-2.98h-142.974c-3.604 0-6.527 2.922-6.527 6.527v39.802c0 2.295 1.19 4.304 2.98 5.468l19.288 19.287h168.62c5.897 0 10.677-4.78 10.677-10.677v-10.832z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.487 491.771h-142.974c-3.605 0-6.527-2.922-6.527-6.527v-39.802c0-3.605 2.922-6.527 6.527-6.527h142.975c3.605 0 6.527 2.922 6.527 6.527v39.802c-.001 3.605-2.923 6.527-6.528 6.527z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m289.347 21.351 15.324 31.05c5.579 11.305 16.364 19.14 28.839 20.953l34.265 4.979c31.416 4.565 43.96 43.172 21.227 65.331l-24.795 24.169c-9.027 8.799-13.146 21.477-11.015 33.902l5.853 34.127c5.366 31.289-27.475 55.149-55.574 40.377l-30.648-16.113c-11.158-5.866-24.489-5.866-35.647 0l-30.648 16.113c-28.099 14.773-60.94-9.088-55.574-40.377l5.853-34.127c2.131-12.425-1.988-25.103-11.015-33.902l-24.795-24.169c-22.733-22.159-10.189-60.766 21.227-65.331l34.265-4.979c12.475-1.813 23.26-9.648 28.839-20.953l15.324-31.05c14.051-28.468 54.645-28.468 68.695 0z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.225 68.55c-4.175 2.427-8.819 4.089-13.734 4.803l-34.265 4.979c-31.416 4.565-43.96 43.172-21.227 65.331l24.795 24.169c9.027 8.799 13.146 21.477 11.015 33.902l-5.853 34.127c-5.367 31.289 27.475 55.149 55.574 40.377l30.648-16.113c11.158-5.866 24.488-5.866 35.647 0l30.648 16.113c13.32 7.003 27.698 5.315 38.574-1.721z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.997 143.664-24.792 24.176c-5.643 5.497-9.356 12.485-10.831 19.992-.908 4.524-.989 9.226-.178 13.896l5.854 34.131c2.821 16.458-4.929 30.856-16.993 38.655-10.88 7.037-25.262 8.723-38.59 1.719l-30.645-16.101c-5.578-2.935-11.691-4.394-17.82-4.394v-99.103l.227.065-.097-.097-.13-.195v-156.404c13.653 0 27.321 7.118 34.342 21.354l15.323 31.035c3.373 6.859 8.675 12.436 15.112 16.166 4.167 2.432 8.821 4.086 13.734 4.8l34.261 4.978c18.16 2.627 30.013 16.636 32.38 32.267 1.749 11.414-1.558 23.704-11.157 33.06z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m156.633 187.838c.893 4.522.976 9.227.175 13.896l-5.853 34.127c-5.367 31.289 27.475 55.149 55.574 40.377l30.648-16.113c11.158-5.866 24.488-5.866 35.647 0l30.648 16.113c28.099 14.773 60.94-9.088 55.574-40.377l-5.853-34.127c-2.131-12.425 1.988-25.103 11.015-33.902l24.795-24.169c9.596-9.354 12.885-21.636 11.143-33.054z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m353.192 201.734c-.801-4.669-.718-9.375.175-13.896l-243.512-77.228c-1.742 11.418 1.547 23.7 11.143 33.054l24.795 24.169c9.027 8.799 13.146 21.477 11.015 33.902l-5.853 34.127c-5.367 31.289 27.475 55.149 55.574 40.377l30.648-16.113c11.158-5.866 24.489-5.866 35.647 0l30.648 16.113c28.099 14.773 60.94-9.088 55.574-40.377z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.775 78.332-34.265-4.979c-4.908-.713-9.546-2.37-13.716-4.792l-151.686 206.06c10.857 6.951 25.165 8.587 38.422 1.617l30.648-16.113c11.158-5.866 24.488-5.866 35.647 0l30.648 16.113c28.099 14.773 60.94-9.088 55.574-40.377l-5.853-34.127c-2.131-12.425 1.988-25.103 11.015-33.902l24.795-24.169c22.731-22.159 10.187-60.766-21.229-65.331z",
    fill: "url(#SVGID_14_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m479.982 75.394c-15.155 9.946-28.071 23.023-37.835 38.305-2.196 3.436-7.289 3.443-9.494.013-9.806-15.254-22.758-28.296-37.941-38.199-3.37-2.198-3.377-7.221-.013-9.429 15.155-9.946 28.071-23.023 37.835-38.305 2.196-3.436 7.288-3.444 9.494-.013 9.807 15.254 22.759 28.296 37.942 38.199 3.369 2.199 3.376 7.222.012 9.429z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.302 385.792c-15.155 9.946-28.071 23.023-37.835 38.305-2.196 3.436-7.289 3.443-9.494.013-9.806-15.254-22.758-28.296-37.941-38.199-3.37-2.198-3.377-7.221-.013-9.429 15.155-9.946 28.071-23.023 37.835-38.305 2.196-3.436 7.288-3.444 9.494-.013 9.807 15.254 22.759 28.296 37.942 38.199 3.368 2.199 3.375 7.222.012 9.429z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.262 182.516c-10.717 7.033-19.851 16.281-26.756 27.088-1.553 2.43-5.154 2.435-6.714.009-6.935-10.787-16.094-20.01-26.831-27.013-2.383-1.554-2.388-5.107-.009-6.668 10.717-7.033 19.851-16.281 26.755-27.088 1.553-2.43 5.154-2.435 6.714-.009 6.935 10.787 16.094 20.01 26.831 27.013 2.384 1.555 2.389 5.107.01 6.668z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.015 203.9c-10.717 7.033-19.851 16.281-26.756 27.088-1.553 2.43-5.154 2.435-6.714.009-6.935-10.787-16.094-20.01-26.831-27.013-2.383-1.554-2.388-5.107-.009-6.668 10.717-7.033 19.851-16.281 26.755-27.088 1.553-2.43 5.154-2.435 6.714-.009 6.935 10.787 16.095 20.01 26.831 27.013 2.384 1.555 2.389 5.107.01 6.668z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.199 352.224c-10.717 7.033-19.851 16.281-26.756 27.088-1.553 2.43-5.154 2.435-6.714.009-6.935-10.787-16.094-20.01-26.831-27.013-2.383-1.554-2.388-5.107-.009-6.668 10.717-7.033 19.851-16.281 26.755-27.088 1.553-2.43 5.154-2.435 6.714-.009 6.935 10.787 16.095 20.01 26.831 27.013 2.384 1.555 2.389 5.107.01 6.668z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.33 68.994c-10.717 7.033-19.851 16.281-26.756 27.088-1.553 2.43-5.154 2.435-6.714.009-6.935-10.787-16.094-20.01-26.831-27.013-2.383-1.554-2.388-5.107-.009-6.668 10.717-7.033 19.851-16.281 26.755-27.088 1.553-2.43 5.154-2.435 6.714-.009 6.935 10.787 16.095 20.01 26.831 27.013 2.384 1.555 2.389 5.107.01 6.668z",
    fill: "url(#SVGID_20_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAward);
export default __webpack_public_path__ + "static/media/icon-award.33f750d4a84261e25ca1b84a4f6ac4e2.svg";
export { ForwardRef as ReactComponent };